// extracted by mini-css-extract-plugin
module.exports =  {"footerNote":"footerNote__A5oKi","reportIcon":"reportIcon__krIEL","title":"title__6JCCN"};